import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const PresentYellowIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="#4DB18D"
      fillRule="evenodd"
      d="m160.143 53.43-5.555 6.376a1.533 1.533 0 0 1-2.688-.902 1.53 1.53 0 0 1 .374-1.114l5.54-6.376a1.53 1.53 0 0 1 1.65-.454 1.54 1.54 0 0 1 1.051 1.35 1.53 1.53 0 0 1-.372 1.12"
      clipRule="evenodd"
    />
    <path
      fill="#FC0"
      fillRule="evenodd"
      d="m195.326 67.855-6.077-5.794a1.53 1.53 0 0 1-.362-1.669 1.54 1.54 0 0 1 1.403-.972 1.54 1.54 0 0 1 1.094.431l6.078 5.869a1.537 1.537 0 1 1-2.136 2.21zM94.123 20.576l2.614-8.034a1.568 1.568 0 1 1 2.986.956l-2.613 8.034a1.568 1.568 0 1 1-2.987-.956M52.579 56.67l6.466-5.42a1.536 1.536 0 0 1 1.986 2.344l-6.481 5.48a1.536 1.536 0 1 1-1.971-2.359z"
      clipRule="evenodd"
    />
    <path
      fill="#D40511"
      fillRule="evenodd"
      d="m82.804 49.442-2.24-4.032a1.494 1.494 0 0 1 .597-2.09 1.49 1.49 0 0 1 2.09.597l2.24 4.032a1.536 1.536 0 0 1-1.168 2.274 1.54 1.54 0 0 1-1.52-.78"
      clipRule="evenodd"
    />
    <path
      fill="#FC0"
      fillRule="evenodd"
      d="m159.696 24.34 8.317-1.494a1.517 1.517 0 1 1 .538 2.987l-8.318 1.493a1.519 1.519 0 0 1-1.515-2.359c.23-.33.581-.556.978-.627M121.406 36.42l1.031 8.393c.024.196.01.395-.042.586s-.142.368-.263.524a1.52 1.52 0 0 1-1.002.57 1.504 1.504 0 0 1-1.68-1.307l-1.03-8.392a1.503 1.503 0 0 1 2.417-1.375 1.5 1.5 0 0 1 .569 1.001"
      clipRule="evenodd"
    />
    <path
      fill="#D40511"
      fillRule="evenodd"
      d="m206.825 34.628-.791 4.48a1.516 1.516 0 0 1-2.987-.522l.806-4.48a1.52 1.52 0 0 1 .623-.98 1.51 1.51 0 0 1 2.111.37 1.51 1.51 0 0 1 .253 1.133z"
      clipRule="evenodd"
    />
    <path
      fill="#58B694"
      fillRule="evenodd"
      d="m145.3 2.77 4.3 1.657a1.53 1.53 0 0 1 .852.81 1.533 1.533 0 0 1-.781 2.028 1.53 1.53 0 0 1-1.176.03l-4.3-1.658a1.53 1.53 0 0 1-.852-.811 1.533 1.533 0 0 1 .781-2.028 1.54 1.54 0 0 1 1.176-.029"
      clipRule="evenodd"
    />
    <path
      fill="#D40511"
      fillRule="evenodd"
      d="m32.434 43.888 4.3 1.657a1.537 1.537 0 0 1-1.105 2.867l-4.3-1.642a1.544 1.544 0 0 1 1.105-2.883"
      clipRule="evenodd"
    />
    <path
      fill="#4DB18D"
      fillRule="evenodd"
      d="m12.231 69.364 2.898 7.944a1.535 1.535 0 1 1-2.883 1.06L9.35 70.424a1.535 1.535 0 1 1 2.882-1.06M50.115 13.005l5.585 6.377a1.54 1.54 0 0 1-2.33 2.016L47.8 15.02a1.536 1.536 0 0 1 2.315-2.016"
      clipRule="evenodd"
    />
    <path
      fill="#D40511"
      fillRule="evenodd"
      d="m52.534 91.614-1.493-4.375a1.495 1.495 0 0 1 1-1.941 1.493 1.493 0 0 1 1.927.985l1.493 4.39a1.49 1.49 0 0 1-.986 1.942 1.493 1.493 0 0 1-1.941-1"
      clipRule="evenodd"
    />
    <path
      fill="#58B694"
      fillRule="evenodd"
      d="m221.938 81.474 4.584-.403a1.5 1.5 0 0 1 1.628 1.359 1.51 1.51 0 0 1-.798 1.463 1.5 1.5 0 0 1-.561.165l-4.585.403a1.5 1.5 0 0 1-1.462-.798 1.488 1.488 0 0 1 .177-1.657 1.5 1.5 0 0 1 1.017-.532"
      clipRule="evenodd"
    />
    <path
      fill="url(#dhl__illustrations_presentyellowillustration_svg_a)"
      d="m86.806 158.874 19.428-3.838-32.973-16.382-19.428 3.838z"
      opacity={0.5}
    />
    <path fill="#634509" d="m106.234 102.964 57.942-10.379-32.973-16.382-57.942 10.379z" />
    <path fill="#C39000" d="m65.57 74.71 57.942-10.379 7.691 11.872-57.942 10.379z" />
    <path
      fill="#996A0D"
      d="m154.693 103.307 9.482-10.722-32.972-16.382-9.483 10.707zM106.234 102.963l27.313.687-32.987-16.396-27.299-.672z"
    />
    <path fill="#C39000" d="M106.234 102.963v52.073l-32.973-16.382V86.582z" />
    <path fill="#FCCE09" d="M106.234 102.964v52.072l57.941-10.379V92.585z" />
    <path fill="#FDDE84" d="m113.671 88.284 57.941-10.379-7.437 14.68-57.941 10.378z" />
    <path fill="#D40511" d="M164.112 122.243v-11.589l-57.944 10.468v11.588z" />
    <path fill="#B60000" d="M106.168 132.71v-11.588l-32.897-14.206v10.841z" />
    <defs>
      <linearGradient
        id="dhl__illustrations_presentyellowillustration_svg_a"
        x1={74.668}
        x2={79.905}
        y1={151.946}
        y2={140.761}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
